export interface IdpSettingsModel {}

export interface IdpSetupModel {
  public_id: string;
}

export interface IdpModel<
  TSettings extends IdpSettingsModel = IdpSettingsModel,
  TIdpProtocol extends IdpProtocol = IdpProtocol,
  TIdpType extends IdpType = IdpType,
> {
  idp: TIdpType;
  is_default: boolean;
  name: string;
  protocol: TIdpProtocol;
  public_id: string;
  settings: TSettings;
}

export interface IdpAttributesModel {
  id: string;
  first_name: string;
  last_name: string;
  name: string;
  email: string;
  avatar: string;
  locale: string;
  time_zone: string;
}

export enum IdpProtocol {
  Saml = 'saml2',
  Oauth = 'oauth2',
}

export enum IdpType {
  Generic = 'generic',
  Okta = 'okta',
}
